import type { EventTypeValue, GrantKey } from "./types";

/** Event catalogue labels for access nav and matrices. */
export const EVENT_TYPE_OPTIONS: { value: EventTypeValue; label: string }[] = [
    { value: "injection", label: "Injection" },
    { value: "shockwave", label: "Shockwave" },
    { value: "surgery", label: "Surgery" },
    { value: "education", label: "Consultation" },
    { value: "product", label: "Product" },
    { value: "medication", label: "Medication" },
];

export const STAFF_ROLES = ["CLINICIAN", "SECRETARY", "MANAGER", "ADMIN"] as const;

export const ACCESS_ATTRIBUTES = [
    "injection",
    "shockwave",
    "surgery",
    "education",
    "product",
    "medication",
    "forms",
    "schedules",
    "labels",
] as const;

export type AccessAttribute = (typeof ACCESS_ATTRIBUTES)[number];

export const EVENT_ATTRIBUTES: EventTypeValue[] = [
    "injection",
    "shockwave",
    "surgery",
    "education",
    "product",
    "medication",
];

export const GRANT_ATTRIBUTES: GrantKey[] = ["forms", "schedules", "labels"];

export function navKeyFromPathname(pathname: string): string {
    const segment = pathname.replace(/\/$/, "").split("/").pop() ?? "users";
    if (segment === "users" || segment === "access") return "all-users";
    return segment;
}
